module.exports = __webpack_public_path__ + "media/Loops 110 Vocals.274e1785.wav";